import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  Audit,
  AuditResponse,
  CalculateAuditActionsCostsResponse,
  CorrectiveActionPrioritiesResponse,
  CorrectiveActionStatusResponse,
  SourceAuditType,
} from '../../types/auditTypes'
import {
  addAuditApi,
  addAuditsToActionApi,
  calculateAuditActionsCostsApi,
  deleteAuditApi,
  getAllAudits,
  getAuditByActionIdApi,
  getAuditbyIdApi,
  getAuditsByMissionIdApi,
  getCorrectiveActionPrioritiesForAuditApi,
  getCorrectiveActionStatusForAuditApi,
  removeAuditsFromActionApi,
  updateAuditApi,
} from '../../api/auditApi'
import { handleError } from '../../utils/errorHandler'

export const getAudits = createAsyncThunk<
  {
    audits: Audit[]
    total: number
    totalPages: number
    status?: number
    erreur?: boolean
    message?: string
  },
  { search?: string; page?: number; pageSize?: number },
  { rejectValue: string }
>('audit/getAllAudits', async ({ search, page, pageSize }, thunkAPI) => {
  try {
    const response = await getAllAudits({ search, page, pageSize })
    return {
      audits: response.audits,
      total: response.total,
      totalPages: response.totalPages,
      status: response.status,
      message: response.message,
      erreur: response.erreur,
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const deleteAudit = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('audit/deleteAudit', async (AuditId, thunkAPI) => {
  try {
    await deleteAuditApi(AuditId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addAudit = createAsyncThunk<Audit, Audit, { rejectValue: string }>(
  'audit/addAudit',
  async (newAudit, thunkAPI) => {
    try {
      const response = await addAuditApi(newAudit)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const getAuditbyId = createAsyncThunk<
  Audit,
  string,
  { rejectValue: string }
>('audit/getAuditbyId', async (AuditId, thunkAPI) => {
  try {
    const response = await getAuditbyIdApi(AuditId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updateAudit = createAsyncThunk<
  Audit,
  { updatedAudit: Audit; _id: string },
  { rejectValue: string }
>('audit/updateAudit', async ({ updatedAudit, _id }, thunkAPI) => {
  try {
    const response = await updateAuditApi(updatedAudit, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getAuditsByMissionId = createAsyncThunk<
  AuditResponse,
  string,
  { rejectValue: string }
>('audit/getAuditsByMissionId', async (MissionId, thunkAPI) => {
  try {
    const response = await getAuditsByMissionIdApi(MissionId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getAuditByActionId = createAsyncThunk<
  AuditResponse,
  string,
  { rejectValue: string }
>('audit/getAuditByActionId', async (ActionId, thunkAPI) => {
  try {
    const response = await getAuditByActionIdApi(ActionId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const addAuditsToAction = createAsyncThunk<
  Audit[],
  { SourceAudit: string[]; _id: string },
  { rejectValue: string }
>('audit/addAuditsToAction', async ({ SourceAudit, _id }, thunkAPI) => {
  try {
    const response = await addAuditsToActionApi(SourceAudit, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const removeAuditsFromAction = createAsyncThunk<
  Audit[],
  { SourceAudit: SourceAuditType; _id: string },
  { rejectValue: string }
>('audit/removeAuditsFromAction', async ({ SourceAudit, _id }, thunkAPI) => {
  try {
    const response = await removeAuditsFromActionApi(SourceAudit, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const calculateAuditActionsCosts = createAsyncThunk<
  CalculateAuditActionsCostsResponse,
  string,
  { rejectValue: string }
>('audit/calculateAuditActionsCosts', async (auditId, thunkAPI) => {
  try {
    const response = await calculateAuditActionsCostsApi(auditId)
    return response
  } catch (error: any) {
    console.error('Error:', error)
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getCorrectiveActionPrioritiesForAudit = createAsyncThunk<
  CorrectiveActionPrioritiesResponse,
  string,
  { rejectValue: string }
>('audit/getCorrectiveActionPrioritiesForAudit', async (auditId, thunkAPI) => {
  try {
    const response = await getCorrectiveActionPrioritiesForAuditApi(auditId)
    return response
  } catch (error: any) {
    console.error('Error:', error)
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getCorrectiveActionStatusForAudit = createAsyncThunk<
  CorrectiveActionStatusResponse,
  string,
  { rejectValue: string }
>('audit/getCorrectiveActionStatusForAudit', async (auditId, thunkAPI) => {
  try {
    const response = await getCorrectiveActionStatusForAuditApi(auditId)
    return response
  } catch (error: any) {
    console.error('Error:', error)
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
